import { Button, Skeleton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { SituacaoAssinatura } from "../../../../models/assinatura";
import { useAssinatura } from "../../../../providers/assinaturaProvider";
import CardInformacaoAssinatura from "./cardInformacaoAssinatura";
import { IconAward } from "@tabler/icons-react";
import Plano from "../../../../models/plano";
import PlanoDb from "../../../../db/planoDb";
import { getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";

export default function CardAssinatura() {
  const assinatura = useAssinatura();
  const [plano, setPlano] = useState<Plano>();

  useEffect(() => {
    if (!!assinatura?.plano.id)
      getDoc(new PlanoDb().doc({ planoId: assinatura.plano.id })).then((doc) =>
        setPlano(doc.data())
      );
  }, [assinatura?.plano.id]);

  return (
    <CardInformacaoAssinatura
      alerta={assinatura && assinatura.situacao === SituacaoAssinatura.UNPAID}
      titulo={!!plano ? `Plano ${plano.name}` : "Assinatura"}
      Icone={IconAward}
      conteudo="Data da próxima cobrança:"
      destaque={
        !!assinatura ? (
          <Typography variant="dataMono" fontSize={16}>
            {assinatura.dataFinalCicloCobranca.format("DD [de] MMMM [de] YYYY")}
          </Typography>
        ) : (
          <Skeleton variant="text" animation={false} />
        )
      }
      rodape={
        !!assinatura ? (
          <Button
            component={Link}
            variant="text"
            to="/termo-de-adesao/"
            target="_blank"
            sx={{ color: "accentInk" }}
          >
            Termo de Adesão
          </Button>
        ) : (
          <></>
        )
      }
    />
  );
}
